<template>
  <div v-if="allPlan && tablePrice" class="payment-infoWrapper textStyleFile">
    <div class="payment-col">
      <span class="payment-title
 ">Багцын нэр: </span>{{ getName }}
    </div>
    <div class="payment-col">
      <span class="payment-title
 ">Төлсөн дүн: </span>{{ getTotalPrice }}₮
    </div>
    <div class="payment-col">
      <span class="payment-title
 ">Авсан огноо: </span>{{ getFormatDate(info.boughtDate) }}
    </div>
    <div class="payment-col">
      <span class="payment-title
 ">Тэмдэгтийн тоо: </span>{{ info.planCharacterCount }}
    </div>
    <!-- <div class="payment-col"><span class="payment-title
 ">Төлөв: </span> 
 <div
                class="circle"
                :class="getStatusColor()"
              ></div>{{ $t(info.status) }}</div>  -->
  </div>
</template>
<script>
import { format } from "date-fns";
import { mapState, mapActions } from "vuex";
export default {
  name: "OrderInfo",
  data: () => ({
    name: "",
  }),
  props: {
    info: {
      planId: Number,
      boughtDate: String,
      pageCount: Number,
      planCharacterCount: Number, 
    },
  },
  computed: {
    ...mapState(["tablePrice", "allPlan"]),
    getToken: function () {
      return this.$cookie.get("token");
    },
    getTotalPrice: function () {
      let table = this.tablePrice[this.info.planId];
      let unitPrice = 0;
      for (let i = table.length - 1; i >= 0; i--) {
        if (table[i].PageCount <= this.info.pageCount) {
          unitPrice = table[i].PagePrice;
          break;
        }
      }
      return unitPrice
    },
    getName() {
      let plan = this.allPlan.find((plan) => plan.ID == this.info.planId);
      if (plan) return plan.Name;
      else return "";
    },
    getLength() {
      let plan = this.allPlan.find((plan) => plan.ID == this.info.planId);
      if (plan) return plan.Character;
      else return "";
    },
  },
  methods: {
    ...mapActions(["showErrorMessage", "checkError", "setSynthState"]),
    getFormatNumber(number) {
      return Intl.NumberFormat().format(number);
    },
    getFormatDate(date) {
      var currentDate = new Date(date);
      currentDate.setHours(currentDate.getHours());
      return format(currentDate, "yyyy/MM/dd HH:mm");
    },
    getPageCount(characterLength) {
      return Math.ceil(characterLength / 3750);
    },
    getStatusColor() {
      switch (this.info.status) {
        case "using":
          return "payment-using";
        case "purchased":
          return "payment-ready";
        default:
          return "payment-exp";
      }
    },
  },
};
</script>

<style>
.payment-infoWrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 5px;
  width: 100%;
  height: 65px;
  align-items: center;
  transition: 0.2s ease-out;
  border-bottom: 1px solid #e8ebed;
  cursor: pointer;
}

.payment-infoWrapper:hover {
  background-color: #f8f8f8;
  transition: 0.2s ease-out;
}

.textStyleFile {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  text-align: left;
}

.payment-title {
  display: none;
  margin-right: 8px;
  width: 120px;
  color: #767676;
}

.payment-col {
  display: flex;
}

@media screen and (max-width: 768px) {
  .payment-col {
    display: flex;
    align-items: center;
    height: 30px;
  }

  .payment-infoWrapper {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(5, 1fr);
    height: auto;
    padding: 8px;
  }

  .payment-title {
    display: block;
  }
}

.payment-exp {
  background-color: #f11a1a;
}

.payment-using {
  background-color: #34a853;
}

.payment-ready {
  background-color: #fe6d26;
}

.circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  margin-right: 4px;
}
</style>
